import React from 'react'

export default function Contact(){

  return (
    <main>
      {/* Page Header */}
      <section className="container-fluid page-banner black-banner" style={{background: 'url(/img/Contact_Header.jpg) center no-repeat', height: '400px', backgroundSize: 'cover', backgroundPositionY: '54%'}}>
        <div className="container py-5">
          <div className="row align-items-center py-4">
            <div className="col-md-6 text-center text-md-left">
              <h1 className="display-4 mb-4 mb-md-0 text-secondary">Contact Us</h1>
            </div>
            {/* <div className="col-md-6 text-center text-md-right">
              <div className="d-inline-flex align-items-center">
                <a className="btn btn-sm btn-outline-light" href="/">Home</a>
                <i className="fas fa-angle-double-right text-light mx-2"></i>
                <a className="btn btn-sm btn-outline-light disabled" href="">Contact Us</a>
              </div>
            </div> */}
          </div>
        </div>
      </section>

      {/* Contact Section */}
      <section className="py-5">
        <div className="container">
          <div className="row align-items-end mb-4">
            <div className="col-lg-6">
              <h6 className="text-secondary font-weight-semi-bold text-uppercase mb-3">Contact Us</h6>
              <h1 className="section-title mb-3" style={{color: '#5d4037'}}>Contact Us</h1>
            </div>
            <div className="col-lg-6">
              <p className="text-muted mb-3">Ready to discuss your pharmaceutical needs? Contact our team today.</p>
            </div>
          </div>

          <div className="row">
            <div className="col-lg-7 mb-5 mb-lg-0">
              <div className="card border-0 shadow-sm">
                <div className="card-body p-4">
                  <p className="lead text-muted mb-4">
                    Get in touch with Lakulish Pharmaceuticals, an India-based pharmaceutical and healthcare export partner, for business inquiries, global collaborations, contract manufacturing, and distribution opportunities.
                  </p>

                  <div className="mb-4">
                    <h4 className="text-primary mb-3">
                      <i className="fas fa-building mr-2"></i>Business Inquiries & Partnerships
                    </h4>
                    <p className="text-muted mb-3">
                      For product inquiries, exports, regulatory support, and long-term business collaborations:
                    </p>
                    <p className="mb-2">
                      <i className="fas fa-envelope text-primary mr-2"></i>
                      <strong>Email:</strong> <a href="mailto:lakulishpharma@gmail.com">lakulishpharma@gmail.com</a>
                    </p>
                    <p className="mb-2">
                      <i className="fas fa-phone text-success mr-2"></i>
                      <strong>Mobile:</strong> +91-99745-25039
                    </p>
                    <p className="text-muted">
                      Our business development team typically responds within 24–48 working hours.
                    </p>
                  </div>

                  <div>
                    <h4 className="text-primary mb-3">
                      <i className="fas fa-user-tie mr-2"></i>Careers at Lakulish Pharmaceuticals
                    </h4>
                    <p className="text-muted mb-3">
                      Looking to build a career in the pharmaceutical, healthcare, regulatory, or export sector?
                      Send your resume or inquiry to:
                    </p>
                    <p className="mb-0">
                      <i className="fas fa-envelope text-warning mr-2"></i>
                      <strong>Email:</strong> <a href="mailto:careers.lakulishpharma@gmail.com">careers.lakulishpharma@gmail.com</a>
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-lg-5">
              <div className="card border-0 shadow-sm h-100">
                <div className="card-body p-0">
                  <iframe
                    style={{width: '100%', height: '100%', minHeight: '400px', border: '0'}}
                    src="https://www.google.com/maps?q=C-315%2C%20Siddharth%20Annexe%203%2C%20Vemali%2C%20Vadodara-391740%2C%20Gujarat%2C%20India&output=embed"
                    frameBorder="0"
                    allowFullScreen=""
                    aria-hidden="false"
                    tabIndex="0"
                    title="Office Location"
                  ></iframe>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Contact Information Cards */}
      <section className="py-5" style={{backgroundColor: '#f5f5f0'}}>
        <div className="container">
          <div className="row g-4">
            <div className="col-lg-4">
              <div className="card border-0 shadow-sm h-100 text-center">
                <div className="card-body">
                  <div className="mb-4">
                    <i className="fas fa-map-marker-alt fa-3x text-primary"></i>
                  </div>
                  <h4 className="card-title text-primary mb-3">Our Office</h4>
                  <p className="card-text text-muted">
                    C-315, Siddharth Annexe 3,<br />
                    Vemali, Vadodara-391740,<br />
                    Gujarat, India
                  </p>
                </div>
              </div>
            </div>
            <div className="col-lg-4">
              <div className="card border-0 shadow-sm h-100 text-center">
                <div className="card-body">
                  <div className="mb-4">
                    <i className="fas fa-phone-alt fa-3x text-success"></i>
                  </div>
                  <h4 className="card-title text-primary mb-3">Call Us</h4>
                  <p className="card-text text-muted mb-2">Speak directly with our pharmaceutical experts</p>
                  <p className="card-text"><strong>+91 9974525039</strong></p>
                </div>
              </div>
            </div>
            <div className="col-lg-4">
              <div className="card border-0 shadow-sm h-100 text-center">
                <div className="card-body">
                  <div className="mb-4">
                    <i className="fas fa-envelope fa-3x text-warning"></i>
                  </div>
                  <h4 className="card-title text-primary mb-3">Email Us</h4>
                  <p className="card-text text-muted mb-2">Send us your inquiries and requirements</p>
                  <p className="card-text"><strong>lakulishpharma@gmail.com</strong></p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </main>
  )
}
